import { FieldType } from "core";

export const noSortableTypes = [ FieldType.File, FieldType.GeoPoint, FieldType.Array, FieldType.Relation, FieldType.Polygon ];
